import React, { useRef, useState, useEffect, useMemo } from "react"
import { connect } from "react-redux"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { LOCALES } from "constants/locales"

import InviteIntroJp from "./introJp"
import InviteIntroCommon from "./introCommon"


const InviteIntro = (props) => {
  if (process.env.LOCALE === LOCALES.JA) {
    return <InviteIntroJp {...props} />
  }
  return <InviteIntroCommon {...props} />;
}

export default connect(mapStateToProps, mapDispatchProps)(InviteIntro)
